import { useState } from "react";
import { Sidebar } from "@/components";
import { UserV2, action } from "@/types";
import styles from "../style.module.scss";
import { UserFormV2Simplified } from "./UserFormV2Simplified";
import { UserFormV2 } from "./UserFormV2";
import { useUserMeV2Info } from "@/hooks/useUserMeV2Info";

export interface UserSidebarV2Props {
  userData?: UserV2 | null;
  onSubmit: (data: UserV2, operation: action) => void;
  onClose: () => void;
}

export const UserSidebarV2 = ({
  onClose,
  onSubmit,
  userData,
}: UserSidebarV2Props) => {
  const [modified, setModified] = useState(false);
  const { isPlatformSuperAdmin } = useUserMeV2Info();

  return (
    <Sidebar onClose={onClose} modified={modified}>
      <article className={styles.wrapper}>
        {isPlatformSuperAdmin ? (
          <UserFormV2
            onSubmit={onSubmit}
            selectedUser={userData}
            setModified={setModified}
          />
        ) : (
          <UserFormV2Simplified
            onSubmit={onSubmit}
            selectedUser={userData}
            setModified={setModified}
          />
        )}
      </article>
    </Sidebar>
  );
};
